// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1bdw1","search":"Settings_search__138HP","filter":"Settings_filter__1b5IT"};